import { PasswordRule } from '@/utils/passwordPolicy';

interface PasswordStrengthHintsProps {
  rules: PasswordRule[];
  className?: string;
}

export default function PasswordStrengthHints({
  rules,
  className = '',
}: PasswordStrengthHintsProps) {
  return (
    <ul
      className={`mt-2 space-y-1 text-xs ${className}`}
      aria-label='Password requirements'
    >
      {rules.map((rule) => (
        <li
          key={rule.key}
          className={`flex items-center gap-1.5 ${
            rule.passed
              ? 'text-green-600 dark:text-green-400'
              : 'text-gray-500 dark:text-gray-400'
          }`}
        >
          <span
            aria-hidden='true'
            className={`inline-flex h-3.5 w-3.5 items-center justify-center rounded-full text-[9px] font-bold ${
              rule.passed
                ? 'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300'
                : 'bg-gray-100 text-gray-400 dark:bg-gray-700 dark:text-gray-500'
            }`}
          >
            {rule.passed ? '✓' : '·'}
          </span>
          <span>{rule.label}</span>
        </li>
      ))}
    </ul>
  );
}
